import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${colors.grey1};
	height: 87%;
	overflow-y: scroll;

	@media (max-width: 1440px) {
		height: 86%;
	}

	@media (max-width: 1366px) {
		height: 84%;
	}
`;
